// error.interceptor.ts
import {
  HttpRequest,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpEvent,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { inject } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";

// Using the new functional interceptor approach for Angular standalone
export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const toastr = inject(ToastrService);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = "An error occurred";

      if (error.error instanceof ErrorEvent) {
        // Client-side error
        errorMessage = error.error.message;
      } else {
        // Server-side error
        switch (error.status) {
          case 0:
            errorMessage =
              "Network error. Please check your internet connection.";
            break;
          case 400:
            errorMessage =
              error.error?.message || "Bad request. Please check your input.";
            break;
          case 401:
            errorMessage =error.error?.message || "Unauthorized access. Please log in again.";
            // Redirect to unauthorized page
            router.navigate(["/unauthorized"]);
            break;
          case 403:
            errorMessage =
              error.error?.message || "Access forbidden. You do not have permission to perform this action.";
            break;
          case 404:
            errorMessage =error.error?.message || "Resource not found.";
            break;
          case 409:
            errorMessage =
              error.error?.message || "Conflict. The resource already exists.";
            break;
          case 422: 
            errorMessage =
              error.error?.message ||
              "Validation error. Please check your input.";
            break;
          case 429:
            errorMessage = "Too many requests. Please try again later.";
            break;
          case 500:
            errorMessage = error.error?.message ||"Server error. Please try again later.";
            break;
          case 502:
            errorMessage =error.error?.message || "Bad gateway. Please try again later.";
            break;
          case 503:
            errorMessage =error.error?.message || "Service unavailable. Please try again later.";
            break;
          case 504:
            errorMessage =error.error?.message || "Gateway timeout. Please try again later.";
            break;
          default:

              errorMessage =
                error.error?.message ||
                `Error ${error.status}: ${error.statusText}`;
            break;
        }
      }

      if(error.error?.statusCode === 1100){
        return throwError(() => error);
      }

      // Show error notification (except for 401 errors since we're redirecting)
      if (error.status !== 401) {
        toastr.error(errorMessage);
      }
      // Log error for debugging (in development)
      if (error.status !== 401 && error.status !== 403) {
        console.error("HTTP Error:", error);
      }

      return throwError(() => error);
    })
  );
};
